<template>
  <b-container fluid class="p-2 layout-container">
    <b-row>
      <b-col cols="3">
        <b-button to="/home" variant="outline-primary"><font-awesome-icon icon="angle-left" /> Back to home</b-button>
      </b-col>
      <b-col cols="6">
        <h1>Form Builder</h1>
      </b-col>
      <b-col cols="3">
         <b-button to="/preview" variant="outline-dark" title="Preview Form" class="mr-5"> <font-awesome-icon icon="eye" /></b-button>
        <b-button
          :disabled="isLoading"
          @click="onSaveJsonData"
          variant="outline-primary"
          class="mr-2"
        >
          <span v-if="isLoading">
            <b-spinner small type="grow"></b-spinner>Saving...
          </span>
          <span v-else>Save Form</span>
        </b-button>
        <b-button variant="outline-danger">Publish</b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-tabs content-class="mt-3" justified>
        <b-tab title="Configuration" active href="/form/configuration"><p>I'm the first tab</p></b-tab>
        <b-tab title="Details" href="/form/details"><p>I'm the second tab</p></b-tab>
        <b-tab title="Builder" href="/form/builder"><p>I'm a disabled tab!</p></b-tab>
        <b-tab title="JSON" href="/form/builder"><p>I'm a disabled tab!</p></b-tab>
        <b-tab title="CSS" href="/form/builder"><p>I'm a disabled tab!</p></b-tab>
        <b-tab title="JS" href="/form/builder"><p>I'm a disabled tab!</p></b-tab>
      </b-tabs>
      <!-- <b-nav tabs>
        <b-nav-item to="/form/configuration" :active="$route.name === 'config'">Configuration</b-nav-item>
        <b-nav-item to="/form/details" :active="$route.name === 'details'">Details</b-nav-item>
        <b-nav-item to="/form/builder" :active="$route.name === 'builder'">Builder</b-nav-item> -->
        <!-- <b-nav-item to="/form/preview" :active="$route.name === 'preview'">Preview</b-nav-item> -->
        <!-- <b-nav-item to="/form/json" :active="$route.name === 'json'">JSON</b-nav-item>
        <b-nav-item to="/form/css" :active="$route.name === 'css'">CSS</b-nav-item>
        <b-nav-item to="/form/js" :active="$route.name === 'js'">JS</b-nav-item>
      </b-nav> -->
    </b-row>
  </b-container>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import { HTTP } from "../utils/HTTP";
import { Helper } from "../helpers";

export default {
  name: "Layout",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      form: "form1",
      isLoading: "isLoading"
    })
  },
  methods: {
    async onSaveJsonData() {
      // console.log("--------------------onSaveJsonData");
      let payload = this.form;
      let token = "Bearer " + localStorage.getItem("accessToken");
      try {
        let result = await HTTP(
          "put",
          "v1/form/edit/" + this.form.formId,
          payload,
          { Authorization: token }
        );
        if (result) {
          Helper.makeToast(this.$bvToast, "success", "Form Save Success");
        }
      } catch (error) {
        Helper.makeToast(
          this.$bvToast,
          "danger",
          "Form not save please try again"
        );
      }
    }
  }
};
</script>
<style>
#app {
  overflow: hidden;
}
.nav-tabs .nav-item {
  border-bottom: 0 !important;
}
.nav-tabs:hover {
  border-bottom: 0 !important;
}
a:hover {
  text-decoration: none !important;
}
.layout-card-container {
  height: 100vh;
}
</style>
